import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { get } from "lodash";
import zh from "Intl/zh";
import en from "Intl/en";

interface IInitialState {
  locale: string;
  messages: any;
  allMessages: any;
}

const initialState: IInitialState = {
  locale: "zh",
  messages: { ...zh },
  allMessages: { zh, en },
};

export const IntlSlice = createSlice({
  name: "intl",
  initialState: initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<string>) => {
      const targetMessage = get(state.allMessages, action.payload);
      if (action.payload && targetMessage) {
        state.messages = targetMessage;
        state.locale = action.payload;
      }
    },
    setMessages: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        state.messages = action.payload;
      }
    },
    setAllMessages: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        state.allMessages = { ...state.allMessages, ...action.payload };
      }
    },
  },
});

export const mapLocale = (state: RootState) => state.intl.locale;
export const mapMessages = (state: RootState) => state.intl.messages;
export const mapAllMessages = (state: RootState) => state.intl.allMessages;
export const { setLocale, setMessages, setAllMessages } = IntlSlice.actions;

export default IntlSlice.reducer;
